var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8375 23.8375V23.4063C52.8375 17.3125 50.4562 11.575 46.1437 7.26254C41.8312 2.94996 36.0938 0.568787 30 0.568787C17.4001 0.568787 7.16252 10.825 7.16252 23.4063V23.8375C3.50625 25.3938 0.9375 29.0125 0.9375 33.2312C0.9375 38.8562 5.5125 43.4313 11.1375 43.4313H16.2C17.7562 43.4313 19.0125 42.175 19.0125 40.6188V25.8437C19.0125 24.3062 17.7562 23.0312 16.2 23.0312H12.8063C13.0125 13.7124 20.6438 6.19379 30 6.19379C34.5938 6.19379 38.9062 7.99371 42.1687 11.2375C45.3375 14.4063 47.1 18.5875 47.1937 23.0312H43.8C42.2438 23.0312 40.9875 24.3062 40.9875 25.8437V40.6188C40.9875 42.175 42.2438 43.4313 43.8 43.4313H48.8625C54.4875 43.4313 59.0625 38.8562 59.0625 33.2312C59.0625 29.0125 56.4938 25.3938 52.8375 23.8375Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorF);
export default __webpack_public_path__ + "static/media/VectorF.fbb44e7b84da274da8c056ef741f4ce3.svg";
export { ForwardRef as ReactComponent };